import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import { FilterService, FilterMatchMode } from 'primeng/api';
import Material from '@primeuix/themes/material';

/**
 * PrimeNG + animations application singletons, co-located with the PrimeNG concern.
 *
 * These MUST be registered exactly once, at the application's environment injector
 * (app.module.ts providers, or app.config.ts once fully standalone) - NOT on the
 * `providers` array of LTPrimeNgModule. That module is imported by many standalone
 * components to pull in PrimeNG declarables; any provider on it would be re-created
 * per component injector, producing duplicate animation renderer factories and
 * PrimeNG configs (the cause of the grid not de-loading rows on paging/filtering).
 *
 * makeEnvironmentProviders() enforces this: Angular will error if this is placed on
 * a component's `providers`, so the duplication footgun cannot reappear.
 */
export function provideLtPrimeNg(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Material,
        options: {
          prefix: 'p',
          darkModeSelector: '.dark-theme',
        },
      },
      ripple: true,
      filterMatchModeOptions: {
        text: [FilterMatchMode.CONTAINS, FilterMatchMode.STARTS_WITH, FilterMatchMode.NOT_CONTAINS, FilterMatchMode.ENDS_WITH, FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS],
        numeric: [FilterMatchMode.EQUALS, FilterMatchMode.NOT_EQUALS, FilterMatchMode.LESS_THAN, FilterMatchMode.LESS_THAN_OR_EQUAL_TO, FilterMatchMode.GREATER_THAN, FilterMatchMode.GREATER_THAN_OR_EQUAL_TO],
        date: [FilterMatchMode.DATE_IS, FilterMatchMode.DATE_IS_NOT, FilterMatchMode.DATE_BEFORE, FilterMatchMode.DATE_AFTER],
      },
    }),
    FilterService,
  ]);
}
